import React, { FC, PropsWithChildren } from "react";

import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";
import { useTranslation } from "react-i18next";

import { AddDocumentIcon } from "@/assets/icons";

import { UploadErrors } from "../../type";
import { getHasFileErrors } from "../../utils";
import UploadErrorMessages from "../UploadErrorMessages/UploadErrorMessages";
import { StyledChooseFileLabel, StyledFileUploaderContainer, StyledUploadArea, StyledUploadAreaText } from "./styled";

type DropZoneProps = {
    hasMaximumFiles: boolean;
    errors: UploadErrors;
    rootProps: DropzoneRootProps;
    inputProps: DropzoneInputProps;
};

const DropZone: FC<PropsWithChildren<DropZoneProps>> = ({
    hasMaximumFiles,
    errors,
    rootProps,
    inputProps,
    children,
}) => {
    const hasFileErrors = getHasFileErrors(errors);
    const { t } = useTranslation();

    return (
        <StyledFileUploaderContainer>
            {hasFileErrors && <UploadErrorMessages errors={errors} />}
            <StyledUploadArea {...rootProps} $error={hasFileErrors} data-testid="upload-area">
                <input data-testid="upload-area-input" {...inputProps} />
                <StyledUploadAreaText>
                    <AddDocumentIcon />
                    <div>
                        {hasMaximumFiles ? (
                            t("FileUploader.Errors.MaxFiles")
                        ) : (
                            <>
                                {t("FileUploader.Drag&Drop")}{" "}
                                <StyledChooseFileLabel>{t("FileUploader.ChooseFile")}</StyledChooseFileLabel>
                            </>
                        )}
                    </div>
                </StyledUploadAreaText>
            </StyledUploadArea>
            {children}
        </StyledFileUploaderContainer>
    );
};

export default DropZone;
